import React from 'react';
import { useHistory } from 'react-router';


const Project = ({ data }) => {
    // react-router hook
    const history = useHistory();
    return (
        <div onClick={() => history.push(`/project/${data.id}`)} className='bg-gray-200 rounded shadow-lg cursor-pointer transition transform lg:hover:scale-105'>
            <div className=''>
                <img className='w-full h-full object-contain rounded' src={data.image} alt={data.title} />
            </div>
            <div className='text-justify'>
                <h2 className='text-lg font-bold text-center text-gray-800'>{data.title}</h2>
                <p className='text-xs font-extralight text-center pb-3'>{data.sub_title}</p>
                <p className='text-sm line-clamp-4 px-3 mb-2'>{data.body}</p>
            </div>
        </div>
    )
}

export default Project;
